import {
    Component,
    ojs,
    app,
    state,
    State,
    v,
    payload,
} from "modular-openscriptjs";
import {
    either,
    monetary,
    minimizeString,
    isQualifiedUrl,
} from "../../helpers";
import { dc, uc } from "../../declarations";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");
const userCurrency = dc.userCurrency;

export default class SearchResultProductView extends Component {
    render(product, ...args) {
        const p = product instanceof State ? product.value : product;
        if (!p?.id) return h.empty();

        const hasImage = p.images && p.images.length > 0;
        let imagePath = hasImage ? p.images[0].path : p.thumbnail_path;
        const finalHasImage = !!imagePath;

        const ownerName = p.company?.name || p.owner?.name || "Carata Seller";
        const price = p.final_price || p.selling_price || p.price;

        return h.div(
            {
                class: "search-result-card overflow-hidden rounded-4 bg-white mb-4 transition-all hover-shadow-lg border-0",
                style: "display: grid; grid-template-columns: 120px 1fr; min-height: 120px; box-shadow: 0 4px 20px rgba(0,0,0,0.05);",
            },

            // Image/Fallback Section
            h.div(
                {
                    class: "position-relative overflow-hidden rounded-4",
                    style: "background: #f8f9fa;",
                },
                either(
                    finalHasImage,
                    () =>
                        h.img({
                            src: imagePath,
                            class: "w-100 h-100 object-fit-cover",
                            alt: p.name,
                            loading: "lazy",
                            style: "min-height: 100px",
                        }),
                    () =>
                        h.div(
                            {
                                class: "w-100 d-flex flex-column align-items-center justify-content-center p-3 text-center",
                                style: "height: 100px; background: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);",
                            },
                            h.i({
                                class: "bi bi-box2 text-muted opacity-50 fs-2 mb-1",
                            }),
                            h.span(
                                {
                                    class: "fw-bold small text-muted opacity-75",
                                    style: "font-size: 0.65rem;",
                                },
                                "NO IMAGE",
                            ),
                        ),
                ),
                // Floating bottom-right add to cart
                h.div(
                    {
                        class: "position-absolute bottom-0 end-0 p-2",
                    },
                    h.button(
                        {
                            class: "btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0 border",
                            style: "width: 32px; height: 32px; background: rgba(255, 255, 255, 0.95); backdrop-filter: blur(4px);",
                        },
                        h.i({ class: "fas fa-plus text-dark fa-2x" }),
                    ),
                ),
            ),

            // Content Section
            h.div(
                {
                    class: "py-2 px-3 d-flex flex-column justify-content-between position-relative",
                },

                h.div(
                    h.div(
                        { class: "mb-1" },
                        h.h6(
                            {
                                class: "fw-bold text-dark mb-0 pe-2",
                                style: "font-size: 1rem; line-height: 1.3;",
                            },
                            p.name,
                        ),
                    ),
                    h.div(
                        { class: "d-flex align-items-center mb-2" },
                        h.div({
                            class: "rounded-circle me-2",
                            style:
                                "width: 18px; height: 18px; background: #eee; background-image: url('" +
                                (p.company?.logo || "") +
                                "'); background-size: cover;",
                        }),
                        h.span(
                            {
                                class: "text-secondary fw-medium",
                                style: "font-size: 0.75rem;",
                            },
                            ownerName,
                        ),
                    ),

                    // Description excerpt if no image
                    either(!finalHasImage, () =>
                        h.p(
                            {
                                class: "text-muted mb-0",
                                style: "font-size: 0.85rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;",
                            },
                            p.short_description || "No description available.",
                        ),
                    ),
                ),

                h.div(
                    {
                        class: "d-flex align-items-center justify-content-between mt-2 pt-1",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-2" },
                        h.span(
                            {
                                class: "text-dark",
                                style: "font-size: 1.05rem;",
                            },
                            monetary(price, userCurrency),
                        ),
                    ),
                ),
            ),
            ...args,
        );
    }
}

ojs(SearchResultProductView);
